// Constantes globales de la aplicación

// Estados de carga
export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error'
};

// Roles de usuario
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  MODERATOR: 'moderator',
  // Roles específicos de Keycloak para este realm
  PUNCHIA_DEFAULT: 'default-roles-punchia'
};

// Tipos de notificación
export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

// Estados de conexión
export const CONNECTION_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  CONNECTING: 'connecting',
  DISCONNECTED: 'disconnected'
};

// Tipos de datos para el monitor
export const MONITOR_DATA_TYPES = {
  PING: 'ping',
  SCORE: 'score',
  STATUS: 'status',
  NETWORK: 'network'
};

// Intervalos de tiempo (en milisegundos)
export const TIME_INTERVALS = {
  SECOND: 1000,
  MINUTE: 60 * 1000,
  HOUR: 60 * 60 * 1000,
  DAY: 24 * 60 * 60 * 1000
};

// Tamaños de pantalla para responsive
export const BREAKPOINTS = {
  XS: '480px',
  SM: '768px',
  MD: '1024px',
  LG: '1200px',
  XL: '1400px'
};

// Límites de archivos
export const FILE_LIMITS = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'application/pdf']
};

// Expresiones regulares comunes
export const REGEX_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^\+?[\d\s-()]{10,}$/,
  URL: /^https?:\/\/.+/,
  IP_ADDRESS: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
};

// Mensajes de error comunes
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Error de conexión. Verifica tu conexión a internet.',
  UNAUTHORIZED: 'No tienes permisos para realizar esta acción.',
  NOT_FOUND: 'El recurso solicitado no fue encontrado.',
  VALIDATION_ERROR: 'Por favor, verifica los datos ingresados.',
  SERVER_ERROR: 'Error interno del servidor. Intenta nuevamente.',
  TIMEOUT: 'La solicitud ha tardado demasiado. Intenta nuevamente.'
};

// Mensajes de éxito
export const SUCCESS_MESSAGES = {
  SAVED: 'Guardado exitosamente',
  UPDATED: 'Actualizado exitosamente',
  DELETED: 'Eliminado exitosamente',
  CREATED: 'Creado exitosamente'
}; 